module.exports = __webpack_public_path__ + "static/img/AR.31378dc8.jpg";